(() => {
  const variants = JSON.parse(document.getElementById('fabric-data').textContent);
  const yen = value => new Intl.NumberFormat('ja-JP', {style:'currency',currency:'JPY',maximumFractionDigits:0}).format(value / 100);
  document.querySelectorAll('#apron-lp .buy-form').forEach(form => {
    const color = form.elements.id, quantity = form.elements.quantity;
    const button = form.querySelector('button');
    const message = form.querySelector('.form-message');
    function update() {
      const v = variants[color.value];
      form.querySelector('.unit-price').textContent = yen(v.price);
      form.querySelector('.fabric-name').textContent = v.name;
      form.querySelector('.fabric-photo').src = v.image + '&width=180';
      form.querySelector('.fabric-photo').alt = v.title + 'の生地';
      form.querySelector('.detail').href = 'https://kijimaru.jp/products/' + v.handle + '?variant=' + v.id;
      form.querySelector('.total').textContent = quantity.value ? `${Number(quantity.value)*50}cm 合計 ${yen(v.price * Number(quantity.value))}（税込）` : '長さを選ぶと合計金額が表示されます';
      button.disabled = !v.available;
      button.textContent = v.available ? '選んだ生地をカートに追加' : 'この生地は現在売り切れです';
      message.textContent = '';
    }
    color.addEventListener('change',update);
    quantity.addEventListener('change',update);
    // Shopify's native form performs the add, then opens the store cart.
    // No checkout or payment request is made here.
    form.addEventListener('submit', event => {
      const q = Number(quantity.value), v = variants[color.value];
      if (!v || !v.available || !Number.isInteger(q) || q < 1 || q > 10) {
        event.preventDefault(); message.textContent = '生地と購入する長さを選んでください。'; return;
      }
      if (form.dataset.submitting === 'true') { event.preventDefault(); return; }
      form.dataset.submitting = 'true';
      button.disabled = true; button.textContent = 'カートへ進んでいます…';
    });
    window.addEventListener('pageshow',()=>{delete form.dataset.submitting;update();});
    update();
  });
})();
